module.exports = "/images/checked.svg?9d50fa5f62dbfdfd94ddac02e692e92b";